import { createFileRoute } from '@tanstack/react-router'
import { NoteBackground } from '@/components/note-background'

export const Route = createFileRoute('/notes/$noteId')({ component: NoteBackground })
